// Module
var code = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 42 42\"><path d=\"M21,21a8.9,8.9,0,0,1-2.3-8.6A8.9,8.9,0,1,0,29.6,23.3,8.9,8.9,0,0,1,21,21Z\"/></svg>";
// Exports
module.exports = code;